import { NavLink, Outlet } from 'react-router-dom';
import { Building2, Nfc, ScrollText, FileSignature, Handshake, Percent, UserPen, Users, Zap, UserCog, KeyRound, PieChart, Merge, Plane } from 'lucide-react';
import useMe from '@/hooks/useMe.js';
import { ownerPagesVisible } from '@/lib/session.js';

// Thin shell for the V2 admin section. Each admin surface adds a SUB_NAV
// entry + a child route. owner: true entries show only when /auth/me says so
// (personal-logins); the server refuses everyone else regardless.
const SUB_NAV = [
  { to: '/admin/tap', label: 'TAP', Icon: Nfc },
  { to: '/admin/carriers', label: 'Carriers', Icon: Building2 },
  { to: '/admin/licenses', label: 'Licenses', Icon: ScrollText },
  { to: '/admin/sign', label: 'Sign', Icon: FileSignature },
  { to: '/admin/referrals', label: 'Referrals', Icon: Handshake },
  { to: '/admin/taxes', label: 'Taxes', Icon: Percent },
  { to: '/admin/aircraft-models', label: 'Aircraft models', Icon: Plane },
  { to: '/admin/contact-names', label: 'Names', Icon: UserPen },
  { to: '/admin/people-doors', label: 'People doors', Icon: Users },
  { to: '/admin/automations', label: 'Automations', Icon: Zap },
  { to: '/admin/users', label: 'Users', Icon: UserCog, owner: true },
  { to: '/admin/producer-shares', label: 'Producer shares', Icon: PieChart, owner: true },
  { to: '/admin/account-merge', label: 'Merge accounts', Icon: Merge, owner: true },
  { to: '/admin/sign-in', label: 'Sign-in', Icon: KeyRound, owner: true },
  // Future: Rules, Brokers — add here when ready
];

export default function AdminLayout() {
  const owner = ownerPagesVisible(useMe());
  return (
    <div className="min-h-screen">
      <div className="border-b border-border px-4 pt-4">
        <h1 className="text-xs font-semibold uppercase tracking-[0.18em] text-text-muted">Admin</h1>
        <nav className="mt-3 flex gap-1">
          {SUB_NAV.filter((n) => !n.owner || owner).map(({ to, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                [
                  'flex items-center gap-2 rounded-t-card border-b-2 px-3 py-2 text-sm min-h-[40px]',
                  isActive
                    ? 'border-accent text-accent'
                    : 'border-transparent text-text-muted hover:text-text',
                ].join(' ')
              }
            >
              <Icon size={16} strokeWidth={1.5} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
